import styled from 'styled-components'

import TextField from 'components/field'

const getBottomMargin = props => (props.error ? '20px' : '0')

const LogisterFormField = styled(TextField)`
  padding: 20px 20px 8px 20px;
  margin: -20px -20px 20px -20px;
  & > label {
    margin-bottom: 8px;
  }

  &:nth-child(2) {
    margin-bottom: ${getBottomMargin};
  }
`

export default LogisterFormField
